<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="workbench-approval-main">
      <div class="top-title">当前审批进度</div>
      <div class="approval-result-box">
        <div style="width: 180px;display: flex;justify-content: space-between;">
          <div>
            <div style="font-size: 12px;color: #97A8BE;">提交人</div>
            <div>{{workData.sponsorAccountName}}</div>
            <div>{{workData.sponsorDate}}</div>
          </div>
          <div style="border: 1px solid #D7D7D7;height: 28px;margin: 15px 0;"></div>
        </div>

        <div v-for="item in workData.contractApproveChainStatuses">
          <!--审批通过-->
          <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.approveStatus === '1' && item.approveResult === '1'">
            <div>
              <i class="iconfont el-icon-damai-shenpitongguo" style="color: #4FB07B;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #009933">审批通过</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveAccountName}}</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveDate}}</div>
              <div style="font-size: 12px;color: #97A8BE;width: 240px;">审批意见：{{item.memo || '无'}}</div>
            </div>
          </div>

          <!--审批中-->
          <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.approveStatus === '0'">
            <div>
              <i class="iconfont el-icon-damai-shenpizhong" style="color: #F9A742;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #F9A742">审批中</div>
              <div style="font-size: 12px;color: #97A8BE;line-height: 40px;">{{item.approveAccountName}}</div>
            </div>
          </div>

          <!--审批驳回-->
          <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.approveStatus === '1' && item.approveResult === '2'">
            <div>
              <i class="iconfont el-icon-damai-shenpibohui" style="color: #D81E06;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #D81E06">审批驳回</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveAccountName}}</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveDate}}</div>
              <div style="font-size: 12px;color: #97A8BE;width: 240px;">审批意见：{{item.memo || '无'}}</div>
            </div>
          </div>
        </div>

      </div>

      <div class="top-title">审批详情</div>
      <div class="approval-detail-box">
        <el-tabs type="card" v-model="activeName">
          <el-tab-pane label="基本信息" name="essentialInformation">
            <div class="form-title">住户信息</div>
            <div class="form-line">
              <div>
                <div class="line-text">住户名称：</div>
                <div class="line-info">{{formData.leaseName || '无'}}</div>
              </div>
              <div>
                <div class="line-text">签订人：</div>
                <div class="line-info">{{formData.signerName || '无'}}</div>
              </div>
              <div>
                <div class="line-text">签订人手机：</div>
                <div class="line-info">{{formData.signerPhone || '无'}}</div>
              </div>
            </div>

            <div class="form-title">房源信息</div>
            <div class="form-line" v-for="(roomItem, roomIndex) in formData.roomList" :key="roomIndex">
              <div>
                <div class="line-text">房间号：</div>
                <div class="line-info">{{roomItem._label || '无'}}</div>
              </div>
              <div v-if="formData.rentType == '1'">
                <div class="line-text">床位号：</div>
                <div class="line-info">{{roomItem._bedsLabel || '无'}}</div>
              </div>
            </div>

            <div class="form-title">合同信息</div>
            <div class="form-line">
              <div>
                <div class="line-text">合同开始时间：</div>
                <div class="line-info">{{formData.contractStartDate || '无'}}</div>
              </div>
              <div>
                <div class="line-text">合同结束时间：</div>
                <div class="line-info">{{formData.contractEndDate || '无'}}</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="租金条款" name="rentTerms">
            <div style="height: 400px;overflow-y: auto;">
              <div class="form-title" style="border-left: 3px solid #ffffff;">保证金信息</div>
              <div class="form-line">
                <div>
                  <div class="line-text">保证金金额：</div>
                  <div class="line-info" v-if="formData.leasePledge">{{formData.leasePledge}}元</div>
                  <div class="line-info" v-if="!formData.leasePledge">无</div>
                </div>
                <div>
                  <div class="line-text">币种：</div>
                  <div class="line-info">人民币CNY</div>
                </div>
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">租金信息</div>
              <div v-for="(contractManagerLeaseItem, index) in contractManagerLeaseItems" :key="index" style="padding: 20px 0 10px;margin: 0 5px 20px 0;border: 1px solid #eeeeee;position: relative;border-radius: 3px;">
                <div class="form-line discount-line">
                  <div>
                    <div class="line-text">开始时间：</div>
                    <div class="line-info">{{contractManagerLeaseItem.leaseContractStartDate || '无'}}</div>
                  </div>
                  <div>
                    <div class="line-text">结束时间：</div>
                    <div class="line-info">{{contractManagerLeaseItem.leaseContractEndDate || '无'}}</div>
                  </div>
                  <div>
                    <div class="line-text">合同单价：</div>
                    <div class="line-info" v-if="contractManagerLeaseItem.leaseContractPer">
                      {{contractManagerLeaseItem.leaseContractPer}}
                      <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '1'">元 / 间 / 月</span>
                      <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '2'">元 / 间 / 天</span>
                      <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '3'">元 / 床 / 月</span>
                      <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '4'">元 / 床 / 天</span>
                    </div>
                    <div class="line-info" v-else>无</div>
                  </div>
                  <div>
                    <div class="line-text">提前付款天数：</div>
                    <div class="line-info" v-if="contractManagerLeaseItem.leaseAheadPayDays">{{contractManagerLeaseItem.leaseAheadPayDays}}自然日</div>
                    <div class="line-info" v-else>无</div>
                  </div>
                </div>

                <div class="form-line ">
                  <div>
                    <div class="line-text">租期划分方式：</div>
                    <div class="line-info" v-if="contractManagerLeaseItem.leaseRentDivideType === '1'">按起始日划分</div>
                    <div class="line-info" v-if="contractManagerLeaseItem.leaseRentDivideType === '2'">按自然月划分（首月非整自然月划入第一期）</div>
                  </div>
                  <div>
                    <div class="line-text">计费类型：</div>
                    <div class="line-info" v-if="contractManagerLeaseItem.leasePayUnitType === '1'">按实际天数计费</div>
                    <div class="line-info" v-if="contractManagerLeaseItem.leasePayUnitType === '2'">按月计费</div>
                  </div>
                  <div v-if="contractManagerLeaseItem.leasePayUnitType === '2'">
                    <div class="line-text">年天数：</div>
                    <div class="line-info">{{ contractManagerLeaseItem.daysInYear }}天</div>
                  </div>
                  <div>
                    <div class="line-text">付款周期：</div>
                    <div class="line-info" v-if="contractManagerLeaseItem.leasePayPeriod" >{{contractManagerLeaseItem.leasePayPeriod}}月一付</div>
                    <div class="line-info" v-else >无</div>
                  </div>
                </div>
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">递增率</div>
              <div class="form-line discount-line" v-if="formData.contractManagerIncreaseLeases.length > 0" v-for="item in formData.contractManagerIncreaseLeases">
                <div>
                  <div class="line-text">开始时间：</div>
                  <div class="line-info">{{item.leaseIncreaseTimePoint || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">租金单价递增：</div>
                  <div class="line-info" v-if="item.leaseIncreasePriceRate" >{{item.leaseIncreasePriceRate}}%</div>
                  <div class="line-info" v-else>无</div>
                </div>
                <!--<div>-->
                  <!--<div class="line-text">保证金递增：</div>-->
                  <!--<div class="line-info">{{formData.leaseIncreaseDepositeRate || '无'}}</div>-->
                <!--</div>-->
              </div>
              <div class="form-line discount-line" v-if="formData.contractManagerIncreaseLeases.length === 0" style="text-indent: 4em">
                无
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">优惠</div>
              <div class="form-line" v-if="formData.contractManagerDiscountLeases.length > 0" v-for="item in formData.contractManagerDiscountLeases">
                <div>
                  <div class="line-text">免租期：</div>
                  <div class="line-info" style="width: 330px;" v-if="item.startTime && item.endTime">{{item.startTime}} 至 {{item.endTime}}</div>
                  <div class="line-info" v-else>无</div>
                </div>
                <div>
                  <div class="line-text">备注：</div>
                  <div class="line-info">{{item.memo || '无'}}</div>
                </div>
              </div>
              <div class="form-line discount-line" v-if="formData.contractManagerDiscountLeases.length === 0" style="text-indent: 4em">
                无
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">租金明细</div>
              <div v-if="!formData.leaseContractManagerDetail && !formData.leaseContractManagerDetails" style="padding-left: 10px;">暂无</div>
              <div v-if="formData.leaseContractManagerDetail || formData.leaseContractManagerDetails" style="margin-bottom: 20px;padding-left: 10px;">
                <div style="display: flex;justify-content: space-between;line-height: 30px;">
                <span style="line-height: 40px;">
                  <span style="color: #7387a3;">保证金应收总计：</span>
                  {{rentTotal2_1}} <span style="color: #7387a3; font-size: 12px;">元;</span>
                  <span style="color: #7387a3;">租金系统计算总额：</span>
                  {{rentTotal1}} <span style="color: #7387a3; font-size: 12px;">元</span>
                  <span style="color: #7387a3;">;租金修改后总额：</span>
                  {{rentTotal2}} <span style="color: #7387a3; font-size: 12px;">元</span>
                </span>
                </div>

                <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
                  <div style="width: 300px;">区间</div>
                  <div style="width: 100px;">费用类型</div>
                  <div style="width: 200px;">付款日</div>
                  <div style="width: 150px;">最终单价</div>
                  <div style="width: 100px;">系统计算金额</div>
                  <div style="width: 100px;">修订金额</div>
                </div>
                <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
                  租金保证金
                </div>
                <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
                  <div style="width: 300px;overflow: hidden" :title="formData.leaseContractManagerDetail.duration">{{formData.leaseContractManagerDetail.duration}}</div>
                  <div style="width: 100px;overflow: hidden" :title="formData.leaseContractManagerDetail.feeType">{{formData.leaseContractManagerDetail.feeType}}</div>
                  <div style="width: 200px;overflow: hidden" :title="formData.leaseContractManagerDetail.payDeadline">{{formData.leaseContractManagerDetail.payDeadline}}</div>
                  <div style="width: 150px;overflow: hidden" title="-">-</div>
                  <div style="width: 100px;overflow: hidden" :title="formData.leaseContractManagerDetail.mustReceive">{{formData.leaseContractManagerDetail.mustReceive || '0'}}元</div>
                  <div style="width: 100px;overflow: hidden" :title="formData.leaseContractManagerDetail.actualReceive">{{formData.leaseContractManagerDetail.actualReceive || '0'}}元</div>
                </div>
                <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
                  租金
                </div>
                <div style="text-align: center;line-height: 36px;">
                  <div style="display: flex;justify-content: space-between;" v-for="item in formData.leaseContractManagerDetails" :key="item.duration">
                    <div style="width: 300px;">{{item.duration}}</div>
                    <div style="width: 100px;">{{item.feeType}}</div>
                    <div style="width: 200px;">{{item.payDeadline}}</div>
                    <div style="width: 150px;">{{item.contractPer}}{{item.contractPerText}}</div>
                    <div style="width: 100px;">{{item.mustReceive || '0'}}元</div>
                    <div style="width: 100px;">{{item.actualReceive || '0'}}元</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="物业条款" name="propertyClause">
            <div style="height: 400px;overflow-y: auto;">
              <div class="form-title" style="border-left: 3px solid #ffffff;">保证金信息</div>
              <div class="form-line">
                <div>
                  <div class="line-text">保证金金额：</div>
                  <div class="line-info" v-if="formData.propertyPledge">{{formData.propertyPledge}}元</div>
                  <div class="line-info" v-if="!formData.propertyPledge">无</div>
                </div>
                <div>
                  <div class="line-text">币种：</div>
                  <div class="line-info">人民币CNY</div>
                </div>
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">物业费信息</div>
              <div v-for="(contractManagerPropertyItem, index) in contractManagerPropertyItems" :key="index" style="padding: 20px 0 10px;margin: 0 5px 20px 0;border: 1px solid #eeeeee;position: relative;border-radius: 3px;">
                <div class="form-line discount-line">
                  <div>
                    <div class="line-text">开始时间：</div>
                    <div class="line-info">{{contractManagerPropertyItem.propertyContractStartDate || '无'}}</div>
                  </div>
                  <div>
                    <div class="line-text">结束时间：</div>
                    <div class="line-info">{{contractManagerPropertyItem.propertyContractEndDate || '无'}}</div>
                  </div>
                  <div>
                    <div class="line-text">合同单价：</div>
                    <div class="line-info" v-if="contractManagerPropertyItem.propertyContractPer">
                      {{contractManagerPropertyItem.propertyContractPer}}
                      <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '1'">元 / 间 / 月</span>
                      <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '2'">元 / 间 / 天</span>
                      <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '3'">元 / 床 / 月</span>
                      <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '4'">元 / 床 / 天</span>
                    </div>
                    <div class="line-info" v-else>无</div>
                  </div>
                  <div>
                    <div class="line-text">提前付款天数：</div>
                    <div class="line-info">{{contractManagerPropertyItem.propertyAheadPayDays || '无'}}</div>
                  </div>
                </div>

                <div class="form-line ">
                  <div>
                    <div class="line-text">租期划分方式：</div>
                    <div class="line-info" v-if="contractManagerPropertyItem.propertyRentDivideType === '1'">按起始日划分</div>
                    <div class="line-info" v-if="contractManagerPropertyItem.propertyRentDivideType === '2'">按自然月划分（首月非整自然月划入第一期）</div>
                  </div>
                  <div>
                    <div class="line-text">计费类型：</div>
                    <div class="line-info" v-if="contractManagerPropertyItem.propertyPayUnitType === '1'">按实际天数计费</div>
                    <div class="line-info" v-if="contractManagerPropertyItem.propertyPayUnitType === '2'">按月计费</div>
                  </div>
                  <div v-if="contractManagerPropertyItem.propertyPayUnitType === '2'">
                    <div class="line-text">年天数：</div>
                    <div class="line-info">{{ contractManagerPropertyItem.daysInYear }}天</div>
                  </div>
                  <div>
                    <div class="line-text">付款周期：</div>
                    <div class="line-info" v-if="contractManagerPropertyItem.propertyPayPeriod" >{{contractManagerPropertyItem.propertyPayPeriod}}月一付</div>
                    <div class="line-info" v-else >无</div>
                  </div>
                </div>
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">递增率</div>
              <div class="form-line discount-line" v-if="formData.contractManagerIncreaseProperties.length > 0" v-for="item in formData.contractManagerIncreaseProperties">
                <div>
                  <div class="line-text">开始时间：</div>
                  <div class="line-info">{{item.propertyIncreaseTimePoint || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">物业费单价递增：</div>
                  <div class="line-info">{{item.propertyIncreasePriceRate || '无'}}</div>
                </div>
                <!--<div>-->
                  <!--<div class="line-text">保证金递增：</div>-->
                  <!--<div class="line-info">{{formData.propertyIncreaseDepositeRate || '无'}}</div>-->
                <!--</div>-->
              </div>
              <div class="form-line discount-line" v-if="formData.contractManagerIncreaseProperties.length === 0" style="text-indent: 4em">
                无
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">优惠</div>
              <div class="form-line" v-if="formData.contractManagerDiscountProperties.length > 0" v-for="item in formData.contractManagerDiscountProperties">
                <div>
                  <div class="line-text">免租期：</div>
                  <div class="line-info" style="width: 330px;" v-if="item.startTime && item.endTime">{{item.startTime}} 至 {{item.endTime}}</div>
                  <div class="line-info" v-else>无</div>
                </div>
                <div>
                  <div class="line-text">备注：</div>
                  <div class="line-info">{{item.memo || '无'}}</div>
                </div>
              </div>
              <div class="form-line discount-line" v-if="formData.contractManagerDiscountProperties.length === 0" style="text-indent: 4em">
                无
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">物业明细</div>
              <div v-if="!formData.propertyContractManagerDetail && !formData.propertyContractManagerDetails" style="padding-left: 10px;">暂无</div>
              <div v-if="formData.propertyContractManagerDetail || formData.propertyContractManagerDetails" style="margin-bottom: 20px;padding-left: 10px;">
                <div style="display: flex;justify-content: space-between;line-height: 30px;">
                <span style="line-height: 40px;">
                  <span style="color: #7387a3;">保证金应收总计：</span>
                  {{propertyTotal2_1}} <span style="color: #7387a3; font-size: 12px;">元;</span>
                  <span style="color: #7387a3;">物业费系统计算总额：</span>
                  {{propertyTotal1}} <span style="color: #7387a3; font-size: 12px;">元</span>
                  <span style="color: #7387a3;">；物业费修改后总额：</span>
                  {{propertyTotal2}} <span style="color: #7387a3; font-size: 12px;">元</span>
                </span>
                </div>

                <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
                  <div style="width: 300px;">区间</div>
                  <div style="width: 100px;">费用类型</div>
                  <div style="width: 200px;">付款日</div>
                  <div style="width: 150px;">最终单价</div>
                  <div style="width: 100px;">系统计算金额</div>
                  <div style="width: 100px;">修订金额</div>
                </div>
                <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
                  物业保证金
                </div>
                <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
                  <div style="width: 300px;overflow: hidden" :title="formData.propertyContractManagerDetail.duration">{{formData.propertyContractManagerDetail.duration}}</div>
                  <div style="width: 100px;overflow: hidden" :title="formData.propertyContractManagerDetail.feeType">{{formData.propertyContractManagerDetail.feeType}}</div>
                  <div style="width: 200px;overflow: hidden" :title="formData.propertyContractManagerDetail.payDeadline">{{formData.propertyContractManagerDetail.payDeadline}}</div>
                  <div style="width: 150px;overflow: hidden" title="-">-</div>
                  <div style="width: 100px;overflow: hidden" :title="formData.propertyContractManagerDetail.mustReceive">{{formData.propertyContractManagerDetail.mustReceive}}元</div>
                  <div style="width: 100px;overflow: hidden" :title="formData.propertyContractManagerDetail.actualReceive">{{formData.propertyContractManagerDetail.actualReceive}}元</div>
                </div>
                <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
                  物业费
                </div>
                <div style="text-align: center;line-height: 36px;">
                  <div style="display: flex;justify-content: space-between;" v-for="item in formData.propertyContractManagerDetails">
                    <div style="width: 300px;">{{item.duration}}</div>
                    <div style="width: 100px;">{{item.feeType}}</div>
                    <div style="width: 200px;">{{item.payDeadline}}</div>
                    <div style="width: 150px;">{{item.contractPer}}{{item.contractPerText}}</div>
                    <div style="width: 100px;">{{item.mustReceive}}元</div>
                    <div style="width: 100px;">{{item.actualReceive}}元</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="其他条款" name="othersClause">
            <div style="height: 400px;overflow-y: auto;">
              <div class="form-title" style="border-left: 3px solid #ffffff;">条款信息</div>
              <div class="form-line" v-for="item in formData.others">
                <div>
                  <div class="line-text">费用类型：</div>
                  <div class="line-info">{{item.otherItemName || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">金额：</div>
                  <div class="line-info" v-if="item.otherItemValue">{{item.otherItemValue}}元</div>
                  <div class="line-info" v-if="!item.otherItemValue">无</div>
                </div>
                <div>
                  <div class="line-text">缴费周期：</div>
                  <div class="line-info">{{item.otherItemType === '0' ? '一次性' : (item.otherItemType === '1' ? '按付款周期' : '无')}}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="退租协议" name="rentRefundAgreement" v-if="formData.status === '3' || formData.status === '6' || formData.status === '12' || formData.status === '14'" >
            <div style="height: 400px;overflow-y: auto;">
              <div class="form-title" style="border-left: 3px solid #ffffff;display: flex;justify-content: space-between;padding-right: 20px;">
                <span>账单信息</span>
                <span v-if="rentRefundAgreementData.totalMoneyReceive" style="font-size: 14px"><span style="color: #00A0E6">应收: </span>{{rentRefundAgreementData.totalMoneyReceive}} 元</span>
                <span v-else-if="rentRefundAgreementData.totalMoneyBack" style="font-size: 14px"><span style="color: #f25721">应退: </span>{{rentRefundAgreementData.totalMoneyBack}} 元</span>
                <span v-else style="font-size: 14px"><span style="color: #f25721">应退: </span>0.00 元</span>
              </div>
              <div class="form-line" v-for="contractSurrenderDetail in rentRefundAgreementData.contractSurrenderDetails" >
                <div>
                  <div class="line-text">费用类型：</div>
                  <div class="line-info">{{contractSurrenderDetail.itemName || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">金额：</div>
                  <div class="line-info" v-if="contractSurrenderDetail.itemMoneyReceive > 0">应收：{{contractSurrenderDetail.itemMoneyReceive}}元</div>
                  <div class="line-info" v-else>应退：{{contractSurrenderDetail.itemMoneyBack}}元</div>
                </div>
                <div>
                  <div class="line-text">备注：</div>
                  <div class="line-info">{{contractSurrenderDetail.memo || '无'}}</div>
                </div>
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">检查项</div>
              <div class="form-line discount-line" v-for="item in checkItemDetails" style="align-items: center;">
                <div class="textBox">
                  <span class="line-text">{{ item.itemName }}：</span>
                </div>
                <el-radio-group v-model="item.status" v-if="item.itemName !== '其他'" style="width: 160px;" disabled>
                  <el-radio label="正常">正常</el-radio>
                  <el-radio label="异常">异常</el-radio>
                </el-radio-group>
                <el-input v-if="item.itemName !== '其他' && item.status === '异常'" v-model="item.desc" size="small" placeholder="异常说明" style="width: 220px" disabled/>
                <el-input v-if="item.itemName === '其他'" v-model="item.desc" size="small" placeholder="异常说明" style="width: 400px" disabled/>
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">退租信息</div>
              <div class="form-line discount-line">
                <div>
                  <div class="line-text">退租原因：</div>
                  <div class="line-info">{{rentRefundAgreementData.surrenderReason || '无'}}</div>
                </div>
              </div>
              <div class="form-line discount-line">
                <div>
                  <div class="line-text">备注：</div>
                  <div class="line-info">{{rentRefundAgreementData.memo || '无'}}</div>
                </div>
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">历史账单</div>
              <div v-if="historicalBillData.length === 0" style="padding-left: 10px;">暂无</div>
              <div v-if="historicalBillData.length > 0" style="margin-bottom: 20px;padding-left: 10px;">
                <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
                  <div style="width: 300px;">区间</div>
                  <div style="width: 150px;">费用类型</div>
                  <div style="width: 250px;">付款日</div>
                  <div style="width: 150px;">缴费状态</div>
                  <div style="width: 150px;">应缴金额(元)</div>
                </div>
                <div style="text-align: center;line-height: 36px;">
                  <div style="display: flex;justify-content: space-between;" v-for="item in historicalBillData">
                    <div style="width: 300px;">{{item.duration}}</div>
                    <div style="width: 150px;">{{item.feeType}}</div>
                    <div style="width: 250px;">{{item.payTime || '无'}}</div>
                    <div style="width: 150px;">{{item.payStatusText}}</div>
                    <div style="width: 150px;">{{item.payMoney || '0'}}元</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>


      <div class="operationBox">
        <button-cancel value="撤回" v-if="workType === 'sponsored' && workData.contractApproveChainStatuses[workData.contractApproveChainStatuses.length -1].approveStatus === '0'" @cancel="recallContract" />
        <el-button size="small" class="btn-confirm" v-if="workType === 'pendingApproval'" @click="confirmApprove()">同意</el-button>
        <el-button size="small" class="reject-button" v-if="workType === 'pendingApproval'" @click="rejectApprove()" >驳回</el-button>
        <!--<button-cancel value="加签" v-if="workType === 'pendingApproval'" @cancel="submitAgainDialog = true" />-->
        <button-cancel value="返回" @cancel="toWorkbenchApprovalPage" />
      </div>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="approveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="memo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="passSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="approveRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="rejectMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelReject">取 消</el-button>
          <el-button size="small" type="primary" @click="unpassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="合同加签" :visible.sync="submitAgainDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">
              <b class="red">*</b>
              <span>审批人</span>
            </div>
            <el-select v-model="approveAccountCode" placeholder="请选择" size="mini" style="width: 300px">
              <el-option
                v-for="item in accountList"
                :key="item.code"
                :label="item._labelName"
                :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div class="approveFlexBox">
            <div class="approve_title">
              <b class="red"></b>
              <span>加签备注</span>
            </div>
            <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="additionalSignatureMemo" style="width: 300px;" size="mini" />
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelAdditionalSignature">取 消</el-button>
          <el-button size="small" type="primary" @click="confirmAdditionalSignature">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
  import ButtonCancel from '../../components/Button/ButtonCancel'
  import ButtonAdd from '../../components/common/buttons/button-add'
  import {errorHandler} from '../../utils/errorHandler'
  import {api} from '../api/WorkbenchApproval'
  import ButtonConfirm from '../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../utils/notice'
  import {bus} from '../../utils/bus'

  export default {
    components: {
      ButtonConfirm,
      ButtonAdd,
      ButtonCancel,
      Breadcrumb},
    name: 'approval-detail',
    data () {
      return {
        breadcrumb: [{
          value: '工作台',
          name: 'workbench'
        }, {
          value: '审批详情'
        }],
        approveDialog: false,
        approveRejectDialog: false,
        submitAgainDialog: false,
        workData: {},
        workType: '', // sponsored-我发起的  pendingApproval-待我审批  approved-我已审批
        activeName: 'essentialInformation',
        accountCode: '',
        accountName: '',
        accountList: [],
        contractManagerLeaseItems: [],
        contractManagerPropertyItems: [],
        formData: {},
        memo: '',
        rejectMemo: '',
        approveAccountCode: '',
        additionalSignatureMemo: '',
        rentRefundAgreementData: {
          contractSurrenderDetails: [],
          surrenderReasonArr: []
        },
        historicalBillData: [],

        // 检查项
        checkItemDetails: [
          {itemName: '设施设备', status: '正常', desc: ''},
          {itemName: '吊顶', status: '正常', desc: ''},
          {itemName: '地板', status: '正常', desc: ''},
          {itemName: '墙面', status: '正常', desc: ''},
          {itemName: '钥匙', status: '正常', desc: ''},
          {itemName: '其他', status: '异常', desc: ''},
        ],
      }
    },
    created () {
      // this.workData = this.$route.query.workData
      // this.workType = this.$route.query.workType
      this.workData = jQuery.parseJSON(sessionStorage.getItem('workDetailData'))
      this.workType = sessionStorage.getItem('workDetailActiveName')
      this.accountCode = bus.global.accountCode
      this.accountName = bus.global.accountName
      this.getContractByCode()
      // this.getAccountListByCode()
    },
    methods: {
      // 跳转我的工作台
      toWorkbenchApprovalPage () {
        this.$router.back(-1)
      },
      // 获取审批人员列表
      getAccountListByCode () {
        this.$axios.post(api.getAccountListByCode, {
          accountCode: this.accountCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data.length > 0) {
                data.map(v => {
                  v._labelName = `${v.name} / ${v.actualName}`
                })
              }
              this.accountList = data
            }
          })
          .catch(errorHandler('获取审批人员列表失败'))
      },
      // 获取合同信息
      getContractByCode () {
        this.$axios.get(`${api.getContractByCode}/${this.workData.contractCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              data.roomList.map(roomItem => {
                let bedsList = roomItem.beds || [], bedsNameList = []
                bedsList.map(bedItem => {
                  bedsNameList.push(bedItem.bedsNumber)
                })
                roomItem._bedsLabel = bedsNameList.join(',')
                roomItem._label = `${roomItem.buildingName}/${roomItem.floorName}层/${roomItem.roomNumber}`
              })
              let rentTotal1 = 0
              let rentTotal2 = 0
              let propertyTotal1 = 0
              let propertyTotal2 = 0
              let rentTotal1_1 = 0
              let rentTotal2_1 = 0
              let propertyTotal1_1 = 0
              let propertyTotal2_1 = 0
              if (data.leaseContractManagerDetails) {
                data.leaseContractManagerDetails.map(v => {
                  if (v.contractPerUnit === '1') {
                    v.contractPerText = "元 / 间 / 月"
                  } else if (v.contractPerUnit === '2') {
                    v.contractPerText = "元 / 间 / 天"
                  } else if (v.contractPerUnit === '3') {
                    v.contractPerText = "元 / 床 / 月"
                  } else if (v.contractPerUnit === '4') {
                    v.contractPerText = "元 / 床 / 天"
                  }
                  rentTotal1 = rentTotal1 + parseFloat(v.mustReceive || 0)
                  rentTotal2 = rentTotal2 + parseFloat(v.actualReceive || 0)
                })
              }
              if (data.propertyContractManagerDetails) {
                data.propertyContractManagerDetails.map(v => {
                  if (v.contractPerUnit === '1') {
                    v.contractPerText = "元 / 间 / 月"
                  } else if (v.contractPerUnit === '2') {
                    v.contractPerText = "元 / 间 / 天"
                  } else if (v.contractPerUnit === '3') {
                    v.contractPerText = "元 / 床 / 月"
                  } else if (v.contractPerUnit === '4') {
                    v.contractPerText = "元 / 床 / 天"
                  }
                  propertyTotal1 = propertyTotal1 + parseFloat(v.mustReceive || 0)
                  propertyTotal2 = propertyTotal2 + parseFloat(v.actualReceive || 0)
                })
              }
              if (data.leaseContractManagerDetail) {
                rentTotal1_1 = parseFloat(data.leaseContractManagerDetail.mustReceive || 0)
              }
              if (data.leaseContractManagerDetail) {
                rentTotal2_1 = parseFloat(data.leaseContractManagerDetail.actualReceive || 0)
              }
              if (data.propertyContractManagerDetail) {
                propertyTotal1_1 = parseFloat(data.propertyContractManagerDetail.mustReceive || 0)
              }
              if (data.propertyContractManagerDetail) {
                propertyTotal2_1 = parseFloat(data.propertyContractManagerDetail.actualReceive || 0)
              }
              this.rentTotal1 = rentTotal1.toFixed(2)
              this.rentTotal2 = rentTotal2.toFixed(2)
              this.propertyTotal1 = propertyTotal1.toFixed(2)
              this.propertyTotal2 = propertyTotal2.toFixed(2)
              this.rentTotal1_1 = rentTotal1_1.toFixed(2)
              this.rentTotal2_1 = rentTotal2_1.toFixed(2)
              this.propertyTotal1_1 = propertyTotal1_1.toFixed(2)
              this.propertyTotal2_1 = propertyTotal2_1.toFixed(2)
              if (data.others) {
                if (data.others.length === 0) {
                  data.others = [
                    {
                      otherItemName: '',
                      otherItemValue: ''
                    }
                  ]
                }
              } else {
                data.others = [
                  {
                    otherItemName: '',
                    otherItemValue: ''
                  }
                ]
              }
              this.formData = data
              this.contractManagerPropertyItems = data.contractManagerPropertyItems
              this.contractManagerLeaseItems = data.contractManagerLeaseItems
              this.getSurrenderContractDetailByContractCode()
              this.getListByContractCode()
            }
          })
          .catch(errorHandler('查询合同失败'))
      },

      // 获取合同退租协议
      getSurrenderContractDetailByContractCode () {
        this.$axios.post(`${api.getSurrenderContractDetailByContractCode}`, {
          contractCode: this.workData.contractCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data) {
                this.rentRefundAgreementData = data
                if (data.checkItemDetails) {
                  this.checkItemDetails.map(detail => {
                    data.checkItemDetails.map(v => {
                      if (v.itemName === detail.itemName) {
                        detail.status = v.status
                        detail.desc = v.desc
                      }
                    })
                  })
                }
              }
            }
          })
          .catch(errorHandler('查询合同退租协议失败'))
      },

      // 根据code查历史账单
      getListByContractCode () {
        this.$axios.post(api.getListByContractCode, {
          contractCode: this.workData.contractCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              let rentHistoricalBillData = []
              let propertyHistoricalBillData = []
              data.map(v => {
                if (v.payStatus === '0') {
                  v.payStatusText = '未缴费'
                } else if (v.payStatus === '1') {
                  v.payStatusText = '已缴费'
                }
                if (v.feeType === '租金') {
                  rentHistoricalBillData.push(v)
                } else if (v.feeType === '租金保证金') {
                  this.rentDepositHistoricalBillData = v
                } else if (v.feeType === '物业费') {
                  propertyHistoricalBillData.push(v)
                } else if (v.feeType === '物业保证金') {
                  this.propertyDepositHistoricalBillData = v
                }
              })
              this.rentHistoricalBillData = rentHistoricalBillData
              this.propertyHistoricalBillData = propertyHistoricalBillData
              if (data) {
                this.historicalBillData = data
              }
            }
          })
          .catch(errorHandler('查询历史账单失败'))
      },

      // 撤回审批
      recallContract () {
        this.$confirm('是否确认撤回审批？', '提示', {
          type: 'info'
        })
          .then(() => {
            this.$axios.post(api.recallContract, {
              approveType: this.workData.approveType,
              contractCode: this.workData.contractCode
            })
              .then(res => {
                if (res.data.retCode === 1) {
                  nSuccess('审批已撤回')
                  this.toWorkbenchApprovalPage()
                }
              })
              .catch(errorHandler('审批撤回失败'))
          })
          .catch(() => {
            console.log()
          })
      },

      // 审批通过输入意见
      confirmApprove () {
        this.approveDialog = true
      },

      // 审批驳回输入意见
      rejectApprove () {
        this.approveRejectDialog = true
      },

      // 取消审批通过
      cancelApprove () {
        this.memo = ''
        this.approveDialog = false
      },

      // 审批通过
      passSubmit () {
        this.$axios.post(api.passSubmit, {
          code: this.workData.code,
          contractCode: this.workData.contractCode,
          memo: this.memo,
          contractApproveChainStatusCode: this.workData.contractApproveChainStatuses[0].code
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('审批已通过')
              this.memo = ''
              this.toWorkbenchApprovalPage()
            }
          })
          .catch(errorHandler('审批通过失败'))
      },

      // 取消审批驳回
      cancelReject () {
        this.rejectMemo = ''
        this.approveRejectDialog = false
      },

      // 审批驳回
      unpassSubmit () {
        this.$axios.post(api.unpassSubmit, {
          code: this.workData.code,
          contractCode: this.workData.contractCode,
          memo: this.rejectMemo,
          contractApproveChainStatusCode: this.workData.contractApproveChainStatuses[0].code
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('审批已驳回')
              this.rejectMemo = ''
              this.toWorkbenchApprovalPage()
            }
          })
          .catch(errorHandler('审批通过失败'))
      },

      // 取消加签
      cancelAdditionalSignature () {
        this.submitAgainDialog = false
        this.approveAccountCode = ''
      },

      // 确定加签
      confirmAdditionalSignature () {
        if (!this.approveAccountCode) {
          nError('请选择审批人')
          return false
        }
        let dataObj = this.workData.contractApproveChainStatuses[this.workData.contractApproveChainStatuses.length - 1]

        this.accountList.map(v => {
          if (v.code === this.approveAccountCode) {
            dataObj.approveAccountName = v.name
            dataObj.approveAccountCode = v.code
          }
        })
        this.$axios.post(api.submitAgain, dataObj)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('加签成功')
              this.approveAccountCode = ''
              this.toWorkbenchApprovalPage()
            }
          })
          .catch(errorHandler('加签失败'))
      }
    }
  }
</script>

<style scoped>
  .workbench-approval {
    text-align: left;
  }
  .workbench-approval-main {
    padding: 0 10px;
  }
  .top-title {
    color: #48576A;
    margin: 25px 0 10px 0;
    padding-left: 5px;
    font-size: 16px;
    line-height: 28px;
    border-left: 3px solid #00A0E6;
  }
  .approval-result-box {
    padding: 10px 30px;
    border-radius: 9px;
    color: #48576A;
    border: 1px solid #D7D7D7;
    display: flex;
    line-height: 20px;
    justify-content: flex-start;
    align-items: center;
  }
  .form-title {
    color: #666666;
    font-size: 14px;
    line-height: 24px;
    padding-left: 5px;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line> div {
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 130px;
    text-align: right;
  }
  .line-info {
    width: 215px;
  }
</style>

<style lang="less">
  .workbench-approval {
    .el-tabs__active-bar {
      width: 96px!important;
    }
    .el-tabs--top {
      height: 100%;
      .is-top:nth-child(2) {
        padding-left: 20px!important;
      }
      #tab-rentTerms {
        /*margin: 0 0 0 20px;*/
      }
      .is-top:last-child {
        padding-left: 0;
        .el-tabs__item {
          padding: 0 20px;
        }
      }
      .el-tabs__nav-wrap::after {
        height: 1px;
      }
    }

    .approval-detail-box {
      padding: 20px 10px;
      .el-tabs__content {
        padding-bottom: 20px;
      }
    }

    .btn-confirm {
      border: 0;
      color: #FFF;
      padding: 8px 16px;
      background-color: #00a0e6;
      border-radius: 4px;
    }
    .btn-confirm:hover {
      color: #FFF;
      background-color: #06b3ff;
    }

    .operationBox {
      display: flex;
      justify-content: flex-end;
      border-radius: 4px;
      .reject-button {
        background-color: #f25721;
        color: #FFFFFF;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Workbench/ApprovalDetail.vue